import { render, staticRenderFns } from "./SimulatorResults.vue?vue&type=template&id=6f52d823&"
import script from "./SimulatorResults.vue?vue&type=script&lang=ts&"
export * from "./SimulatorResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports